<script setup lang="ts">
import type { CmsBlockImageText } from "@shopware/composables";
import { useCmsBlock } from "#imports";

const props = defineProps<{
  content: CmsBlockImageText;
}>();

const { getSlotContent } = useCmsBlock(props.content);

const leftContent = getSlotContent("left");
const rightContent = getSlotContent("right");
</script>
<template>
  <div class="row">
    <CmsGenericElement class="col-12 col-md-6" :content="leftContent" />
    <CmsGenericElement class="col-12 col-md-6" :content="rightContent" />
  </div>
</template>
